export default "__VITE_ASSET__CJk6IbuA__"